var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSongOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7796 3.02457C20.405 2.88328 21 3.3588 21 3.99999V6.10247C21 7.73345 19.9035 9.16067 18.3275 9.58091L15 10.4683V20.3936C15 25.0815 10.4174 27.4933 7.92716 25.0031C5.35069 22.4266 7.82017 18.1997 12.9996 17.9426L13.0001 7.93085C12.973 6.0087 13.9096 4.64267 15.6837 4.05131C16.3249 3.83757 17.6771 3.49952 19.7796 3.02457ZM13 19.9439C9.46206 20.1398 8.15535 22.4028 9.34137 23.5888C10.4843 24.7318 13 23.4077 13 20.3936V19.9439ZM19 5.25551C17.652 5.57064 16.7511 5.80372 16.3162 5.94867C15.3815 6.26023 14.9849 6.83871 15 7.91675V8.39838L17.8122 7.64844C18.5126 7.46167 19 6.82735 19 6.10247V5.25551Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSongOutline);
export default __webpack_public_path__ + "static/media/song_outline.faa8f59c87671947b355f4305fedd113.svg";
export { ForwardRef as ReactComponent };